/**
 * Canonicalizes the kiosk to the root URL and keeps a same-document history
 * sentinel so Safari back/forward controls cannot reveal internal app states.
 */
export function installPathlessHistory(): () => void {
  const root = `${window.location.origin}/`;
  window.history.replaceState({ kiosk: "base" }, "", root);
  window.history.pushState({ kiosk: "guard" }, "", root);

  const keepAtRoot = () => {
    if (window.location.pathname !== "/" || window.location.search) {
      window.history.replaceState({ kiosk: "base" }, "", root);
    }
    window.history.forward();
  };

  window.addEventListener("popstate", keepAtRoot);
  return () => window.removeEventListener("popstate", keepAtRoot);
}
